import React from 'react';

const Authorities = () => {
  const authorities = [
    {
      id: 1,
      name: 'Greater Noida Industrial Development Authority',
      logo: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/af8txvkw_483848-greater-noida.jpg',
      link: '#'
    },
    {
      id: 2,
      name: 'Noida Authority',
      logo: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/u59lokvq_Noida_Logo.jpg',
      link: '#'
    },
    {
      id: 3,
      name: 'YEIDA - Yamuna Expressway Industrial Development Authority',
      logo: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/osrvhnd7_yeida.png',
      link: '#'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Working with the Top Development Authorities.
            </h2>
          </div>

          {/* Logos Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center">
            {authorities.map((authority) => (
              <a
                key={authority.id}
                href={authority.link}
                className="group flex items-center justify-center"
              >
                <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-100 hover:border-[#B8944A] transition-all duration-300 hover:shadow-xl w-full h-48 flex items-center justify-center">
                  <img
                    src={authority.logo}
                    alt={authority.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Authorities;
